export enum TipoFiscalEnum {
  NAO_INFORMADO = 0,
  TITULAR = 1,
  SUPLENTE = 2,
}

// Mapeamento para exibição
export const TipoFiscalLabels: Record<TipoFiscalEnum, string> = {
  [TipoFiscalEnum.NAO_INFORMADO]: 'Não informado',
  [TipoFiscalEnum.TITULAR]: 'Titular',
  [TipoFiscalEnum.SUPLENTE]: 'Suplente',
};

// Mapeamento para códigos/slugs
export const TipoFiscalCodes: Record<TipoFiscalEnum, string> = {
  [TipoFiscalEnum.NAO_INFORMADO]: '',
  [TipoFiscalEnum.TITULAR]: '1',
  [TipoFiscalEnum.SUPLENTE]: '2',
};

export const getTipoFiscalOptions = () => {
  return Object.values(TipoFiscalEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value as TipoFiscalEnum,
      label: TipoFiscalLabels[value as TipoFiscalEnum],
      code: TipoFiscalCodes[value as TipoFiscalEnum],
    }));
};

export const getTipoFiscalSlug = (tipoFiscal: TipoFiscalEnum): string => {
  return TipoFiscalCodes[tipoFiscal] || 'Desconhecido';
};

export const getTipoFiscalLabel = (tipoFiscal: TipoFiscalEnum): string => {
  return TipoFiscalLabels[tipoFiscal] || 'TipoFiscal Desconhecido';
};

export const getTipoFiscalPorCodigo = (
  code: string,
): TipoFiscalEnum | undefined => {
  const entry = Object.entries(TipoFiscalCodes).find(
    ([, value]) => value === code,
  );
  return entry ? (Number(entry[0]) as TipoFiscalEnum) : undefined;
};

export const getTipoFiscalLabelPorSlug = (slug: string): string => {
  const tipoFiscal = getTipoFiscalPorCodigo(slug);

  if (tipoFiscal !== undefined) {
    return getTipoFiscalLabel(tipoFiscal);
  }

  return 'Tipo de Fiscal Desconhecido';
};
